export default __webpack_public_path__ + "static/new-roma-3-7cbc45dc6a122e3e769223ae7a4e5514.jpg";